import i18n from '~/utils/i18n';

const CALL_NS = 'admin/call';

export function callT(key: string, translate?: (key: string) => string): string {
  if (translate) {
    const fromHook = translate(key);
    if (fromHook && fromHook !== key) return fromHook;
  }
  const fromI18n = i18n.t(key, { ns: CALL_NS });
  return typeof fromI18n === 'string' && fromI18n !== key ? fromI18n : key;
}
